export default __webpack_public_path__ + "media/images/dashboard_icons/switchbook-9bec910f149e4be078ed2dd419519ac2.svg";